import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BudgetComponent } from '../components/budget/budget.component';

const routes: Routes = [
  // {
  //   path: '',
  //   redirectTo: '',
  //   pathMatch: 'full',
  //   data: { title: 'Apollo - Order List' }
  // },
  {
    path: '',
    component: BudgetComponent,
    // canActivate: [AuthGuard],
    data: { title: 'Apollo - Budgets' }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BudgetRoutingModule { }
